module.exports = __webpack_public_path__ + "static/media/rentBySquareFoot-condoApt.e20a1c7b.png";